export const ProgressiveBonusSlide_4 = {
  name: "progressive_bonus_slide_4",
  posisiton: {
    x: 0,
    y: 0,
  },
  components: [
    {
      name: "slider_bg_title",
      type: "CustomText",
      text: "SPLASH_SLIDE_TITLE_3",
      position: { x: 982 / 2 + 10, y: 30 },
      anchor: { x: 0.5, y: 0 },
    },
    {
      name: "bg",
      type: "Sprite",
      img: "splash_quest_bg_blured",
      position: {
        x: 80,
        y: 145,
      },
    },
    {
      name: "bg",
      type: "Sprite",
      img: "splash_quest_book",
      position: {
        x: 982 / 2,
        y: 100,
      },
      anchor: {
        x: 0.5,
        y: 0,
      },
    },
    {
      name: "quest_text",
      type: "CustomText",
      text: "SPLASH_QUEST_TEXT_0",
      position: { x: 982 / 2, y: 500 },
      anchor: { x: 0.5, y: 0 },
    },
    {
      name: "quest_text",
      type: "CustomText",
      text: "SPLASH_QUEST_TEXT_1",
      position: { x: 982 / 2, y: 525 },
      anchor: { x: 0.5, y: 0 },
    },
  ],
};
